import $ from 'jquery';

$(function () {
  let scrollPos;
  const body = $('body');
  const button = $('.js-filterButton');
  const buttonSp = $('.js-filterButtonSp');
  const filterItems = $('.js-filterItem');
  const drawer = $('.js-filterDrawer');
  const closeButton = $('.js-filterClose');

  /*
   * SP時の挙動
   */
  buttonSp.on('click', function () {
    if (!drawer.hasClass('is-open')) {
      scrollPos = $(window).scrollTop();
      $(this).addClass('is-open');
      drawer.addClass('is-open');
      body.addClass('is-fixed').css({ top: -scrollPos });
    } else {
      closeFilterDrawer(scrollPos);
    }
  });

  /*
   * PC時の挙動
   */
  button.on('click', function () {
    const filter = $(this).data('filter');
    if (!drawer.hasClass('is-open')) {
      scrollPos = $(window).scrollTop();
      drawer.addClass('is-open');
      body.addClass('is-fixed').css({ top: -scrollPos });
    } else if (!filter) {
      closeFilterDrawer(scrollPos);
    }
    if (filter) {
      filterItems.each(function () {
        if ($(this).data('filter') === filter) {
          $(this).children('.js-accordionContents').show();
          $(this).children('.js-accordionTerm').addClass('is-open');
        }
      });
    }
  });

  /*
   * クローズボタンクリック
   */
  closeButton.on('click', function () {
    closeFilterDrawer(scrollPos);
  });

  /*
   * ドロワーを閉じる関数
   */
  const closeFilterDrawer = () => {
    buttonSp.removeClass('is-open');
    drawer.removeClass('is-open');
    $('.js-accordionContents').hide();
    $('.js-accordionTerm').removeClass('is-open');
    body.removeClass('is-fixed').css('top', '');
    $('html, body').scrollTop(scrollPos);
  };
});
